module.exports = __webpack_public_path__ + "static/media/inteiro_note_preto.5ced51db.png";